import SEO from '../components/SEO'
import Hero from '../components/home/Hero'
import Services from '../components/home/Services'
import Portfolio from '../components/home/Portfolio'
import CTA from '../components/home/CTA'
import FloatingCTA from '../components/FloatingCTA'
import { useLanguage } from '../context/LanguageContext'

const Home = () => {
  const { t } = useLanguage()
  
  return (
    <>
      <SEO 
        title={t('seo.home.title')}
        description={t('seo.home.description')}
        keywords={t('seo.home.keywords')}
      />
      <div className="mt-20">
        <Hero />
        <Services />
        <Portfolio />
        <CTA />
        <FloatingCTA />
      </div>
    </>
  )
}

export default Home
